if (!customElements.get('product-buy-now-sticky')) {
  class ProductBuyNowSticky extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.sectionId = this.dataset.section;
      this.moneyFormat = this.dataset.moneyFormat || '₹{{amount}}';
      this.variantsById = {};
    }

    connectedCallback() {
      this.targetElement =
        document.querySelector('#magic-buy-now-btn') ||
        Array.prototype.find.call(
          document.querySelectorAll('.magic-buynow'),
          function (el) { return !el.closest('product-buy-now-sticky'); }
        ) ||
        document.querySelector('[id^="ProductSubmitButton-"]');

      this.footerElement = document.querySelector('footer');
      this.button = this.querySelector('.magic-buynow');
      this.priceNode = document.getElementById('price-' + this.sectionId + '-buy-now-sticky');

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      document.body.addEventListener('change', this.handleVariantChange);
      this.handleScroll();

      const self = this;
      this.loadVariants().then(function () { self.syncFromMain(); });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      document.body.removeEventListener('change', this.handleVariantChange);
    }

    loadVariants() {
      const m = location.pathname.match(/\/products\/([^/?#]+)/);
      if (!m) return Promise.resolve();
      const self = this;
      return fetch('/products/' + m[1] + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          (p.variants || []).forEach(function (v) { self.variantsById[v.id] = v; });
        })
        .catch(function () {});
    }

    formatMoney(cents) {
      const fmt = this.moneyFormat;
      const value = Number(cents) / 100;
      function group(n, precision, thousands, decimal) {
        thousands = thousands || ','; decimal = decimal || '.';
        if (isNaN(n)) return '0';
        n = n.toFixed(precision);
        const parts = n.split('.');
        const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }
      const token = (fmt.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
      let out;
      switch (token) {
        case 'amount_no_decimals': out = group(value, 0); break;
        case 'amount_with_comma_separator': out = group(value, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = group(value, 0, '.', ','); break;
        case 'amount_with_space_separator': out = group(value, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': out = group(value, 0, ' ', ''); break;
        default: out = group(value, 2);
      }
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, out);
    }

    renderPrice(variantId) {
      if (!this.priceNode) return;
      const v = this.variantsById[variantId];
      if (!v) return;
      const price = v.price;
      const compare = v.compare_at_price || 0;
      if (compare > price) {
        this.priceNode.innerHTML =
          '<span class="pbns-price pbns-price--sale">' + this.formatMoney(price) + '</span>' +
          ' <s class="pbns-price pbns-price--was">' + this.formatMoney(compare) + '</s>' +
          ' <span class="pbns-save">Save ' + this.formatMoney(compare - price) + '</span>';
      } else {
        this.priceNode.innerHTML =
          '<span class="pbns-price">' + this.formatMoney(price) + '</span>';
      }
    }

    getAbsoluteTop(element) {
      let top = 0;
      while (element) {
        top += element.offsetTop || 0;
        element = element.offsetParent;
      }
      return top;
    }

    handleScroll() {
      if (!this.targetElement) return;
      const targetTopPosition = this.getAbsoluteTop(this.targetElement);
      const footerTopPosition = this.footerElement ? this.getAbsoluteTop(this.footerElement) : Infinity;
      const isTargetOutOfView = targetTopPosition < window.scrollY;
      const isFooterInView = window.scrollY + window.innerHeight > footerTopPosition;

      if (isTargetOutOfView && !isFooterInView) {
        this.classList.add('show');
      } else {
        this.classList.remove('show');
      }
    }

    syncFromMain() {
      const main = document.getElementById('MainProduct-' + this.sectionId);
      if (!main) return;

      const idInput  = main.querySelector('form[action^="/cart/add"] [name="id"]');
      const qtyInput = main.querySelector('[name="quantity"]');
      const vid = idInput && idInput.value;
      if (this.button && vid) this.button.setAttribute('data-variant-id', vid);
      if (this.button && qtyInput && qtyInput.value) this.button.setAttribute('data-quantity', qtyInput.value);

      if (vid) this.renderPrice(parseInt(vid, 10));
    }

    updateOption(optionName, optionValue) {
      const matches = optionName.match(/options\[(.+)\]/);
      if (matches && matches[1]) optionName = matches[1];
      const optionDisplay = this.querySelector(
        '.product-buy-now-sticky__option[data-option-name="' + optionName + '"]'
      );
      if (optionDisplay) optionDisplay.textContent = optionName + ': ' + optionValue;
    }

    handleVariantChange(event) {
      const target = event.target;
      const productSection = target.closest(`#MainProduct-${this.sectionId}`);
      if (!productSection) return;

      if (target.tagName === 'INPUT' || target.tagName === 'SELECT') {
        const optionName = target.name;
        const optionValue = target.tagName === 'INPUT'
          ? target.value
          : target.options[target.selectedIndex].textContent;
        this.updateOption(optionName, optionValue);
      }
      setTimeout(() => this.syncFromMain(), 50);
    }
  }

  customElements.define('product-buy-now-sticky', ProductBuyNowSticky);
}